module.exports = __webpack_public_path__ + "img/43_38.22676e8a.png";